var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroTrading({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800.115,
    height: 724.36,
    viewBox: "0 0 800.115 724.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-616 -175.714)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(616 176)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(180.635)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 361,
    height: 100,
    rx: 6,
    transform: "translate(0.365 -0.286)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 357,
    height: 94,
    rx: 4,
    transform: "translate(2.365 2.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.732 15.772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.714,205.36a5.1,5.1,0,1,0,0,10.2h20.4a5.1,5.1,0,1,0,0-10.2Z",
    transform: "translate(-265.797 -147.65)",
    fill: "#3fb9ea"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 235.489,
    height: 1.342,
    transform: "translate(78.928 47.818)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.704,
    cy: 29.704,
    r: 29.704,
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.547,192.794l-.744-1.117,24.47-16.314,16.78,8.055L433.19,168l.326.139L481.2,188.48,519.438,169.7l37.128,15.052,46.652,9.483.89,1-47.276-8.931L519.49,171.166l-38.249,18.788L433.314,169.51l-24.169,15.441L392.38,176.9Z",
    transform: "translate(-289.244 -152.468)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.492,205.983a4.361,4.361,0,1,0,0,8.722h45.622a4.361,4.361,0,0,0,.14-8.721H372.492Z",
    transform: "translate(-289.202 -147.569)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.9,181.71a1.781,1.781,0,0,0-2.519,0h0l-7.647,7.647V170.5a1.781,1.781,0,1,0-3.563,0v18.858l-7.647-7.647A1.781,1.781,0,1,0,314,184.223l.006.006,10.689,10.689a1.781,1.781,0,0,0,2.519,0L337.9,184.23A1.781,1.781,0,0,0,337.9,181.71Z",
    transform: "translate(-296.25 -152.375)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 153.54)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 361,
    height: 99,
    rx: 6,
    transform: "translate(0 0.175)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 357,
    height: 95,
    rx: 4,
    transform: "translate(2 2.175)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.49,354.325a5.1,5.1,0,0,0,0,10.2h20.4a5.1,5.1,0,0,0,0-10.2Z",
    transform: "translate(-367.368 -276.375)",
    fill: "#3fb9ea"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 235.489,
    height: 1.342,
    transform: "translate(102.132 68.057)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.704,
    cy: 29.704,
    r: 29.704,
    transform: "translate(23.203 20.238)",
    fill: "#3fb9ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.322,344.564l-.745-1.117,24.47-16.314,16.781,8.055,24.136-15.421.326.139,47.686,20.343,38.236-18.783,37.128,15.051,46.652-41.32.89,1-47.276,41.869-37.343-15.139-38.248,18.788-47.927-20.445L533.92,336.718l-16.761-8.044Z",
    transform: "translate(-390.816 -284)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.276,354.946a4.361,4.361,0,0,0-.142,8.721H542.9a4.361,4.361,0,1,0,0-8.722Z",
    transform: "translate(-390.782 -276.295)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.781,331.412a1.781,1.781,0,0,0,2.519,0h0l7.647-7.647v18.858a1.781,1.781,0,0,0,3.563,0V323.765l7.647,7.647a1.781,1.781,0,1,0,2.519-2.519L451.989,318.2a1.782,1.782,0,0,0-2.519,0l-10.689,10.689a1.781,1.781,0,0,0,0,2.519Z",
    transform: "translate(-397.822 -281.101)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(134.347 307.079)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 362,
    height: 100,
    rx: 6,
    transform: "translate(-0.347 -0.365)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 356,
    height: 94,
    rx: 4,
    transform: "translate(2.653 2.635)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.415,503.288a5.1,5.1,0,1,0,0,10.2h20.4a5.1,5.1,0,1,0,0-10.2Z",
    transform: "translate(-201.103 -429.805)",
    fill: "#3fb9ea"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 235.489,
    height: 1.342,
    transform: "translate(102.323 63.59)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.704,
    cy: 29.704,
    r: 29.704,
    transform: "translate(23.395 15.771)",
    fill: "#3fb9ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.246,490.949l-.744-1.117,24.47-16.315,16.78,8.055,24.137-15.425L439.9,486.628l38.235-18.783L515.261,482.9l46.652-18.741.89,1-47.27,19.293L478.19,469.32l-38.248,18.788-47.927-20.445-24.168,15.442-16.765-8.047Z",
    transform: "translate(-224.551 -434.851)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.193,503.909a4.361,4.361,0,1,0,0,8.722h45.622a4.361,4.361,0,0,0,.142-8.721H331.193Z",
    transform: "translate(-224.508 -429.725)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.707,480.375a1.781,1.781,0,0,0,2.519,0h0l7.647-7.647v18.858a1.781,1.781,0,1,0,3.563.011V472.728l7.647,7.647a1.781,1.781,0,0,0,2.526-2.513l-.006-.006-10.689-10.689a1.782,1.782,0,0,0-2.519,0l-10.689,10.689a1.781,1.781,0,0,0,0,2.519Z",
    transform: "translate(-231.556 -434.531)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M970.659,768.938H711a1.129,1.129,0,0,1,0-2.258H970.659a1.129,1.129,0,0,1,0,2.258Z",
    transform: "translate(444.328 131.136)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1228.808 325.051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.1,309.772c-1.725,8.658-7.882,14.274-13.753,12.538s-9.23-10.169-7.5-18.827a19.511,19.511,0,0,1,4.411-9.26l7.79-36.552,18.215,6-9.618,35.4a21.935,21.935,0,0,1,.439,10.7h0Z",
    transform: "translate(-285.083 5.421)",
    fill: "#f8a8ab"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.38,
    height: 30.334,
    transform: "translate(41.692 525.193)",
    fill: "#f8a8ab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.148,561.8c3.655.327,21.952,1.777,22.87-2.42a17.979,17.979,0,0,0-.572-8.423c-1.756-17.5-2.41-17.694-2.808-17.806-.623-.184-2.44.684-5.391,2.583l-.184.122-.041.214c-.051.276-1.358,6.7-7.555,5.707-4.247-.674-5.626-1.613-6.065-2.073a2.612,2.612,0,0,0,1.123-.939,3.285,3.285,0,0,0,.235-2.736,42.517,42.517,0,0,0-3.288-7.382l-.276-.49-24.3,16.4-15.009,4.288a3.866,3.866,0,0,0-2.5,2.216h0a3.871,3.871,0,0,0,.98,4.37c2.726,2.451,8.137,6.647,13.824,7.167,1.511.143,3.512.194,5.758.194,9.383,0,23.085-.97,23.187-.99Z",
    transform: "translate(-250.088 11.102)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.38,
    height: 30.334,
    transform: "translate(100.92 525.193)",
    fill: "#f8a8ab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.138,561.8c3.655.327,21.952,1.777,22.87-2.42a17.98,17.98,0,0,0-.572-8.423c-1.756-17.5-2.41-17.694-2.808-17.806-.623-.184-2.44.684-5.391,2.583l-.184.122-.041.214c-.051.276-1.358,6.7-7.555,5.707-4.247-.674-5.626-1.613-6.065-2.073a2.613,2.613,0,0,0,1.123-.939,3.285,3.285,0,0,0,.235-2.736,42.513,42.513,0,0,0-3.288-7.382l-.276-.49-24.3,16.4-15.009,4.288a3.866,3.866,0,0,0-2.5,2.216h0a3.871,3.871,0,0,0,.98,4.37c2.726,2.451,8.137,6.647,13.824,7.167,1.511.143,3.512.194,5.758.194,9.383,0,23.085-.97,23.187-.99Z",
    transform: "translate(-132.849 11.102)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.262,101.038,213.11,111.932V64.21h30.079Z",
    transform: "translate(-141.289 1.358)",
    fill: "#f8a8ab"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.029,
    cy: 33.029,
    r: 33.029,
    transform: "translate(42.896 12.721)",
    fill: "#f8a8ab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.331,48.324l-4.554,5.524-8.24-14.417s-10.516.541-10.516-7.259-9.649-8.025-9.649-8.025S189.722.306,218,6.586c0,0,19.613-13.436,29.374-1.95,0,0,29.915,15.06,21.349,41.289L254.5,72.961l-3.226-6.116s1.95-25.688-14.958-18.531Z",
    transform: "translate(-151.992 0.009)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.872,254.19H285.437l-27.3,281.48-31.651-2.042-1.562-202.71L205,419.878,199.172,532.1l-28.843,1.531L166.98,405.972Z",
    transform: "translate(-133.365 5.348)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.051,83.19l-37.777,9.189L166.98,231.94l3.8,25.842,94.6,16.009,16.969-16.009Z",
    transform: "translate(-130.271 1.756)",
    fill: "#3fb9ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.715,82.446l13.252,7.606,26.2,6.289L224.9,298.835l-47.135,10.692-10.41-203.234Z",
    transform: "translate(-73.209 2.399)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.864,91.035v20.054L264.411,321.825H248.32l7.423-210.735,21.849-17.357Z",
    transform: "translate(-219.84 2.741)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.209,108.87l-12.957,2.665s-5.677,2.083-7.739,18.215-2.42,70.306-2.42,70.306l-22.033,87.4,25.025,8.25,11.782-47.027,8.352-139.816Z",
    transform: "translate(-264.35 2.295)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.043,276.559c-5.258,7.1-13.222,9.536-17.786,5.462s-4-13.13,1.256-20.236a19.377,19.377,0,0,1,7.954-6.483l22.666-29.721,13.906,13.212-23.82,27.894a21.978,21.978,0,0,1-4.176,9.863h0Z",
    transform: "translate(-47.992 4.747)",
    fill: "#f8a8ab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.78,99.957,150.133,96.7s14.029,3.482,18.674,21l22.676,85.356-38.461,67.509L132.47,245.613l19.358-61.975L139.77,99.957Z",
    transform: "translate(-4.177 2.04)",
    fill: "#090814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroTrading);
export default __webpack_public_path__ + "static/media/hero_trading.b42c5d0eb3bcff38e96477cc3a0eb509.svg";
export { ForwardRef as ReactComponent };